import React from "react";
import { Controller } from "react-hook-form";
import "./index.css";

const CustomInput = React.memo(
  ({
    control,
    name,
    label,
    type,
    isPassword = false,
    setShowPassword,
    showPassword,
    errors,
  }) => {
    return (
      <div className="flex flex-col">
        <Controller
          control={control}
          name={name}
          render={({ field: { value, onChange } }) => {
            return (
              <div class="input-group">
                <input
                  dir="ltr"
                  class="input-text"
                  value={value}
                  type={type}
                  onChange={onChange}
                  onWheelCapture={(e) => {
                    e.target.blur();
                  }}
                />
                <label class="input-text-label" for="text">
                  {label}
                </label>
                <div className="absolute right-0 top-[50%] translate-y-[-50%]">
                  {value && isPassword && (
                    <img
                      className="w-6 h-6  cursor-pointer"
                      onClick={() => setShowPassword(!showPassword)}
                      src={
                        showPassword ? "./icons/eyeoff.svg" : "./icons/eye.svg"
                      }
                      alt="eye"
                    />
                  )}
                </div>
              </div>
            );
          }}
        />
        {errors && (
          <span className="text-red-500 text-sm">{errors?.message}</span>
        )}
      </div>
    );
  }
);

// Add a custom equality function to compare props if needed
const areEqual = (prevProps, nextProps) => {
  return (
    prevProps.control === nextProps.control &&
    prevProps.isPassword === nextProps.isPassword &&
    prevProps.setShowPassword === nextProps.setShowPassword &&
    prevProps.showPassword === nextProps.showPassword &&
    prevProps.name === nextProps.name &&
    prevProps.label === nextProps.label &&
    prevProps.type === nextProps.type &&
    prevProps.placeholder === nextProps.placeholder &&
    prevProps.className === nextProps.className &&
    prevProps.disabled === nextProps.disabled &&
    prevProps.tabIndex === nextProps.tabIndex &&
    prevProps.errors === nextProps.errors &&
    prevProps.required === nextProps.required
  );
};

export default React.memo(CustomInput, areEqual);
